import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { triggerSearch } from '../../actions';

class TopSearch extends Component {
	componentWillMount() {
		this.props.triggerSearch( this.props.match.params.searchTerm );
	}

	handleSearch( event ) {
		this.props.triggerSearch( event.target.value );
		this.props.history.push( `/search/${event.target.value}` );
	}

	onKeyPress( event ) {
		if ( event.which === 13 /* Enter */ ) {
			event.preventDefault();
		}
	}

	render() {
		return (
			<div className="search-wrap">
				<form role="search" onKeyPress={ this.onKeyPress.bind( this ) }
				      aria-label="Global Search Form" method="get"
				      className="search-form page-search" action="/">
					<label className="glyphicon glyphicon-search" htmlFor="global-isda-search"><span className="sr-only">Search ISDA</span></label>
					<input required={true} id="global-isda-search" type="search" name="s" onChange={ this.handleSearch.bind( this ) } className="form-control" placeholder="Search" value={ this.props.searchTerm } autoComplete="off" />
				</form>
			</div>
		);
	}
}

function mapStateToProps( { searchTerm } ) {
	return { searchTerm };
}

export default withRouter( connect( mapStateToProps, {
	triggerSearch
} )( TopSearch ) );